var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md5":"","d-flex":""}},[_c('validators',{attrs:{"subject":_vm.subject}})],1),_c('v-flex',{attrs:{"xs12":"","md7":"","d-flex":""}},[(_vm.subject)?_c('problem-blank',{attrs:{"subject":_vm.subject}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }